import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tiktok",
  "use": "icon-tiktok-usage",
  "viewBox": "0 0 500 500",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 500 500\" id=\"icon-tiktok\">\n<path d=\"M321.2,80h-59.7v235.7c0,28.1-23,51.1-51.6,51.1c-28.6,0-51.6-23.1-51.6-51.1c0-27.6,22.5-50.1,50-51.1v-59.2\n\tc-60.8,1-109.8,49.6-109.8,110.3c0,61.2,50,110.3,111.8,110.3c61.8,0,111.8-49.6,111.8-110.3V194.8c22.5,16,50,25.6,79.1,26.1v-59.2\n\tC356.4,160.2,321.2,124.1,321.2,80z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol